import { render, staticRenderFns } from "./BatchEntity.vue?vue&type=template&id=b9aa7116&scoped=true"
import script from "./BatchEntity.vue?vue&type=script&lang=js"
export * from "./BatchEntity.vue?vue&type=script&lang=js"
import style0 from "./BatchEntity.vue?vue&type=style&index=0&id=b9aa7116&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9aa7116",
  null
  
)

export default component.exports